// Deliberately renders only what a crawler does not need: proof that hydration
// ran. Page content belongs in the ERB template, where it reaches crawlers that
// never execute JavaScript.
export const HydrationCheck = () => (
  <p className="mt-4 text-sm text-slate-400">
    React {import.meta.env.MODE} hydrated this line through Vite.
  </p>
);
